import { evolve, map, path, pipe, prop, memoizeWith } from 'ramda'
import { utils } from '@digital-commerce/shared-utils'
import { getCacheKey } from '../../../utils/cart'

const { getHSService } = utils.cart

export const isHsFireflyFeatureEnabled = prop('hsFireFly')

export const getStreamPlusService = memoizeWith(getCacheKey('HS-Stream-Plus'), (cart) => {
  if (!cart?.root?.items) return undefined

  return pipe(
    getHSService(['video-streaming']),
    evolve({
      items: map((id) => path(['items', id], cart))
    })
  )(cart)
})

export const shouldRender = (cart, featureFlags) => {
  return getStreamPlusService(cart) && isHsFireflyFeatureEnabled(featureFlags)
}
